// Resim Kütüphanesi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.imageLibrary';

export const inventoryImageLibraryGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Resim Kütüphanesi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Ürün resimlerinizi ve videolarınızı klasörlerde düzenli tutar, toplu olarak ürünlere atarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve konum'),
    toolbar: t(`${G}.regions.toolbar`, 'Klasör / Yükle / Toplu'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Klasörler ve resimler'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Klasör oluşturun'),
      text: t(`${G}.s1.text`, 'Ana Sayfa\'dayken "Klasör Oluştur" ile klasör adını yazın, isterseniz renk ve şube seçin. Aynı adla ikinci klasör açılamaz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Klasör adını ürünün barkodu yaparsanız klasör o ürünle eşlenir: aramada ürün adı / stok kodu / kategori ile bulunur ve Kategori filtresine girer.'),
        t(`${G}.s1.tip2`, 'Şube seçilmezse klasör tüm şirkette kullanılır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Resim veya video yükleyin'),
      text: t(`${G}.s2.text`, '"Resim Yükle" ile dosyaları seçin, her resme bir ad verin ve yükleyin. Hedef klasörü pencerede değiştirebilir, boş bırakıp Ana Dizin\'e yükleyebilirsiniz. Videolar için "Video Yükle"yi kullanın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Resimlerde JPG, PNG, WEBP desteklenir; dosya başına en fazla 10 MB, bir seferde en fazla 10 resim.'),
        t(`${G}.s2.tip2`, 'Bir klasörün içindeyken dosyaları sürükleyip sayfaya bırakarak da yükleyebilirsiniz.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Arayın ve süzün'),
      text: t(`${G}.s3.text`, 'Arama kutusu ad, barkod, stok kodu ve kategoriye göre arar. "Filtre" ile yalnız klasörleri veya yalnız resimleri, "Kategori" ve "Şube" ile ilgili klasörleri gösterin. "Görünüm Boyutu" simgelerin büyüklüğünü ayarlar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kategori filtresindeki "Eşleşmeyen / Kategorisiz", adı bir ürün barkoduna uymayan ya da ürününün kategorisi olmayan klasörleri gösterir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Klasör ve resimlerle çalışın'),
      text: t(`${G}.s4.text`, 'Klasöre tıklayınca içi açılır; üstteki "Ana Sayfa" bağlantısı geri döner. Resme tıklamak büyük önizleme açar. Resme sağ tıklayınca Önizle, İndir, Adını Değiştir, Taşı, Bilgiler ve Sil seçenekleri çıkar; klasöre sağ tıklayınca Düzenle ve Sil.'),
      tips: [
        t(`${G}.s4.tip1`, 'Silinen resim ve klasörler pasife alınır, kalıcı olarak silinmez. Yine de içinde resim olan bir klasör silinirse bu resimlerin bağlantıları kopabilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Resim bilgisini görün'),
      text: t(`${G}.s5.text`, 'Sağ tık menüsündeki "Bilgiler" dosya adını, bulunduğu klasörü, boyutu, türü, tarih bilgisini ve yükleyen kişiyi gösterir. "URL\'yi Kopyala" ile resmin adresini başka bir yere yapıştırabilirsiniz.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Toplu ürün resmi yükleyin'),
      text: t(`${G}.s6.text`, '"Toplu Ürün Resmi Yükle" sihirbazı resimleri barkoda göre ürünlere atar. Bilgisayarınızda her ürün için adı barkod olan bir klasör hazırlayın, resimleri içine koyun. Sihirbazda bu klasörleri içeren ÜST klasörü seçin (Klasör Seç), eşleşen ürünleri kontrol edin (Önizleme) ve "Gönder" deyin (Yükle).'),
      tips: [
        t(`${G}.s6.tip1`, 'Resimler kütüphanede barkod adlı klasöre kaydedilir ve ürüne eklenir; ürünün mevcut resimleri korunur. Ürünün kapak resmi yoksa ilk resim kapak yapılır.'),
        t(`${G}.s6.tip2`, 'Bir ürüne en fazla 8 resim atanır; fazlası atlanır. Barkodu bulunamayan ("Bulunamadı") ya da birden çok ürüne uyan ("Mükerrer") klasörler seçilemez ve gönderilmez.'),
        t(`${G}.s6.tip3`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
